/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_FourInputs */

const cs_enum_four = /** @type {(inputs: Enum_FourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4`)
};

const en_enum_four = /** @type {(inputs: Enum_FourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4`)
};

/**
* | output |
* | --- |
* | "4" |
*
* @param {Enum_FourInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_four = /** @type {((inputs?: Enum_FourInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_FourInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_four(inputs)
	return cs_enum_four(inputs)
});